export default {
  create_title: 'Nouveau compte API Partenaire',
  edit_title: 'Modifier le compte',
  form: {
    name: 'Nom du compte',
    name_placeholder: 'ex. Intégration POS Acme',
    contact_email: 'E-mail de contact',
    scope: 'Accès aux restaurants',
    companies: 'Restaurants',
    scope_selected: 'Restaurants sélectionnés',
    scope_all: 'Tous les restaurants',
    scope_all_help:
      'Les clés de ce compte donnent accès à tous les restaurants de votre organisation, y compris ceux enregistrés ultérieurement.',
    companies_placeholder: 'Sélectionner des restaurants',
    companies_help: 'Les clés émises sur ce compte peuvent lire et écrire uniquement ces restaurants.',
    is_active: 'Actif',
    is_active_help: "Les comptes inactifs sont rejetés lors de l'authentification.",
  },
  buttons: {
    cancel: 'Annuler',
    save: 'Enregistrer',
    create: 'Créer',
  },
  toasts: {
    created: 'Compte API Partenaire créé.',
    updated: 'Compte mis à jour.',
    error: "Impossible d'enregistrer le compte.",
  },
};
